class Subscription {
	getTopics() {
		const topics = [];
		return topics;
	}
}

export default Subscription;
